<template>
    <div>
        <tab name="8"></tab>
        <div class="btn-wrap">
            <div class="l">
                <el-radio-group v-model="dataType" style="margin-bottom: 30px;" size="small" @change="fetch">
                    <el-radio-button :label="1">销售额</el-radio-button>
                    <el-radio-button :label="3">商品数</el-radio-button>
                </el-radio-group>
            </div>
            <div class="r">
                <el-radio-group v-model="granularity" style="margin-bottom: 30px;" size="small" @change="fetch">
                    <el-radio-button :label="1">天</el-radio-button>
                    <el-radio-button :label="2" :disabled="during <= 7">周</el-radio-button>
                    <el-radio-button :label="3" :disabled="during <= 30">月</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="chart-wrap" id="chart-container"></div>
    </div>
</template>

<script>
import Tab from './../../components/tab';
import { Chart } from '@antv/g2';

export default {
    components: {Tab},
    data(){
        return{
            dataType: 1,
            granularity: 1,
            during: null,
            filter: null,
            data: [],
            filterData: [],
            chart: null,
            fetchLoading: false,
        }
    },
    mounted() {
        const {timeStart, timeEnd, ...filter} = this.$route.query;

        this.parsingTime(timeStart, timeEnd);

        this.filter = {timeStart, timeEnd, ...filter};

        this.$nextTick(() => {
            this.initChart();

            this.fetch();
        });
    },
    methods:{
        parsingTime(timeStart, timeEnd) {
            if(!timeStart || !timeEnd) {
                this.granularity = 3;
                this.during = Infinity;
                return;
            }

            this.during = (new Date(timeEnd).getTime() - new Date(timeStart).getTime()) / (24 * 60 * 60 * 1000);

            if(this.during <= 30) {
                this.granularity = 1;
                return 
            }
            
            if(this.during <= 365) {
                this.granularity = 2;
                return 
            }

            this.granularity = 3;
        },
        //获取列表
        async fetch() {
            const {filter, dataType, granularity} = this;

            this.fetchLoading = true;

            const res = await this.$request({
                url:'/sales/goods/goods/salescharts/goodstime',
                method: 'post',
                data: {...filter, dataType, granularity}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchLoading = false;
            });

            const{state, msg, result} = res.data;
            
            if(state !== '1') {
                return this.$message.error(msg || '获取数据失败');
            }

            const {lineSeriesData} = result;

            const filterData = [];

            const data = (lineSeriesData || []).reduce((a, b, index) => {
                const {name, value} = b;

                if(index < 5) {
                    filterData.push(name);
                }

                return a.concat((value || []).map(item => ({name, time: item.name, value: parseFloat(item.value)})));
            }, []);

            this.data = data;
            this.filterData = filterData;

            this.update();
        },
        update() {
            const {chart, data, filterData, dataType} = this;

            chart.data(data);

            chart.filter('name', v => filterData.includes(v));

            

            chart.scale('value', {alias: dataType === 1 ? '金额(元)' : '数量'});

            chart.render();
        },
        initChart() {
            this.chart = new Chart({container: 'chart-container', autoFit: true, height: 500});

            this.chart.tooltip({
                showCrosshairs: true,
                shared: true,
            });

            this.chart.scale({
                time: {
                    range: [0, 1],
                },
                value: {
                    nice: true,
                }
            });

            this.chart.axis('value', {
                label: {
                    formatter: (v) => {
                        return v.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
                    }
                },
                title: {
                    offset: 80,
                    style: {
                        fill: '#aaaaaa'
                    }
                }
            });

            this.chart.legend({
                 position: 'right',
            });

            this.chart
                .line()
                .position('time*value')
                .color('name')
                .shape('smooth');

            this.chart
                .point()
                .position('time*value')
                .color('name')
                .shape('circle');
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-wrap {
    display: flex;

    .l {
        flex: 1;
    }
}

.chart-wrap {
    margin-top: 20px;
}
</style>